import React, { useContext } from "react"
import styled from "styled-components"
import AuthUserContext from "../../providers/AuthProvider"
import {
  CHANGE_USERS_NAME,
  CHANGE_USERS_EMAIL,
  CHANGE_USERS_PASSWORD,
} from "../Layout/routes"
import {
  BreakpointTablet,
  BreakpointMobile,
  PaddingLeftRightDesktop,
  PageHeaderTypeThree,
} from "../../components/Layout/GlobalStyle"
import LockIcon from "react-ionicons/lib/MdLock"
import UserIcon from "react-ionicons/lib/MdPerson"
import LogoutIcon from "react-ionicons/lib/MdLogOut"
import EmailIcon from "react-ionicons/lib/MdMail"
import { Link } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
import UserSettingsHeader from "./UserSettingsHeader"

export const settingsStyles = makeStyles(theme => ({
  saveButton: {
    fontFamily: "var(--Font1NotCondensed)",
    textTransform: "initial",
  },
}))

export const SettingsContainer = styled.div`
  display: flex;
  align-items: center;
  height: inherit;
  width: 100%;
  flex-direction: column;

  .page-title {
    font-size: 28px;
    font-family: var(--Font2);
    font-weight: normal;
    color: #333132;
  }
  min-height: 100vh;

  @media only screen and (max-width: ${BreakpointTablet + "px"}) {
    .page-title {
      font-size: x-large;
    }
  }
  @media only screen and (max-width: ${BreakpointMobile + "px"}) {
    .page-title {
      font-size: large;
    }
  }
`

const Wrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  padding-left: ${PaddingLeftRightDesktop};
  padding-right: ${PaddingLeftRightDesktop};
`

const MainSections = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 20px;

  @media only screen and (max-width: 745px) {
    grid-template-columns: 1fr;
  }
`

const MainSectionItem = styled.div`
  a,
  button {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 8px 14px 8px 14px;
    border-radius: 4px;
    border: 1px #ddd solid;
    background-color: #fff;
    cursor: pointer;
    text-decoration: none;

    :hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    .section-details {
    }

    .section-title {
      font-size: 17px;
      font-family: "Roboto";
      font-weight: normal;
      color: #333132;
    }

    .section-icon {
      display: flex;
      width: 27px;
      height: 37px;
      align-items: center;

      color: black;
      i,
      svg {
        font-size: x-large;
        width: 100%;
      }
    }

    .section-details {
      padding-left: 10px;
      width: 100%;
      display: inline-flex;
      justify-content: center;
      flex-direction: column;
      h2 {
        line-height: 17px;
        margin-top: 0px;
        margin-bottom: 0px;
        font-size: 17px;
        padding-bottom: 0px;
      }

      span {
        line-height: 19px;
        font-size: 12px;
      }
    }
  }

  @media only screen and (max-width: 745px) {
    a {
      height: 52px;

      .section-details {
        h2 {
          font-size: 15px;
          line-height: 15px;
        }

        span {
          font-size: 10px;
        }
      }

      .section-icon {
        width: calc(77px - 36px);
        height: 100%;
      }
    }
  }
`

const Account = props => {
  const userContext = useContext(AuthUserContext)
  let { handleSignOut } = userContext

  return (
    <>
      <SettingsContainer>
        <UserSettingsHeader />

        <Wrapper>
          <PageHeaderTypeThree>Your Account</PageHeaderTypeThree>
          <MainSections>
            <MainSectionItem className="MainSectionItem">
              <Link to={CHANGE_USERS_NAME}>
                <>
                  <div className="section-icon">
                    <UserIcon color={"#3C3C3C"} />
                  </div>
                  <div className="section-details">
                    <h2 className="section-title"> Name</h2>
                  </div>
                </>
              </Link>
            </MainSectionItem>

            <MainSectionItem className="MainSectionItem">
              <Link to={CHANGE_USERS_EMAIL}>
                <>
                  <div className="section-icon">
                    <EmailIcon color={"#3C3C3C"} />
                  </div>
                  <div className="section-details">
                    <h2 className="section-title"> Email</h2>
                  </div>
                </>
              </Link>
            </MainSectionItem>
            <MainSectionItem className="MainSectionItem">
              <Link to={CHANGE_USERS_PASSWORD}>
                <>
                  <div className="section-icon">
                    <LockIcon color={"#3C3C3C"} />
                  </div>
                  <div className="section-details">
                    <h2 className="section-title"> Password</h2>
                  </div>
                </>
              </Link>
            </MainSectionItem>

            <MainSectionItem className="MainSectionItem">
              <button onClick={() => handleSignOut()} className="logout">
                <>
                  <div className="section-icon">
                    <LogoutIcon color={"#3C3C3C"} />
                  </div>
                  <div className="section-details">
                    <h2 className="section-title">Logout</h2>
                  </div>
                </>
              </button>
            </MainSectionItem>
          </MainSections>
        </Wrapper>
      </SettingsContainer>
    </>
  )
}

export default Account
